var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.show_voter_count
      ? _c("span", { staticClass: "rating-stars" }, [
          _c(
            "span",
            {
              staticClass: "rating-value",
              style: "width: " + _vm.percentage + "%",
            },
            [
              _c("span", { staticClass: "sr-only" }, [
                _vm._v(
                  _vm._s(_vm.internal_value) + " / " + _vm._s(_vm.max_rating)
                ),
              ]),
            ]
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.show_voter_count
      ? _c("span", { attrs: { "aria-hidden": "true" } }, [
          _c("strong", [_vm._v(_vm._s(_vm.internal_value))]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.show_voter_count
      ? _c("span", { staticClass: "rating-count" }, [
          _vm._v(
            "(" +
              _vm._s(_vm.voterCount) +
              " " +
              _vm._s(
                _vm.voterCount === 1 ? _vm.__("Rating") : _vm.__("Ratings")
              ) +
              ")"
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.show_fallback
      ? _c("span", { staticClass: "rating-count text-muted" }, [
          _vm._v(_vm._s(_vm.__("No ratings yet"))),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }